import { Lane } from "../../../../hooks/react-query/outbound/freightDetails/useGetDoorAssets";

export const doorAssets = {
  unassigned: {
    destinationSicId: 0,
    destinationSic: "Unassigned",
    laneType: 0,
    summary: {
      bills: 7,
      loadedBills: 6,
      pieces: 5,
      pallets: 4,
      weight: 700,
      loadedWeight: 665,
      pulls: 0,
      publishedTrips: 0,
      unassignedPublishedTrips: 0,
      tags: [
        {
          color: "#777DE9",
          id: 4,
          name: "APTR",
        },
        {
          id: 2,
          name: "UC",
          color: "#FBC02D",
        },
      ],
    },
    indicators: {
      unassignedBillsCount: 2,
      missServiceBillsCount: 3,
      pullsWithNoTrailersCount: 4,
      pullsWithNoTripCount: 5,
      lanesWithNoDoorsCount: 6,
    },
    doors: [],
  },
  default: {
    destinationSicId: 114,
    destinationSic: "ONT",
    laneType: 0,
    summary: {
      bills: 0,
      loadedBills: 0,
      pieces: 0,
      pallets: 0,
      weight: 0,
      loadedWeight: 0,
      pulls: 0,
      publishedTrips: 0,
      unassignedPublishedTrips: 0,
      tags: [
        {
          color: "#777DE9",
          id: 4,
          name: "APTR",
        },
        {
          id: 2,
          name: "UC",
          color: "#FBC02D",
        },
      ],
    },
    indicators: {
      unassignedBillsCount: 2,
      missServiceBillsCount: 3,
      pullsWithNoTrailersCount: 4,
      pullsWithNoTripCount: 5,
      lanesWithNoDoorsCount: 6,
    },
    doors: [
      {
        doorNumber: 7,
        priority: 1,
        laneType: 0,
        doorSics: ["ONT", "DAL"],
        doorTags: [
          {
            color: "#777DE9",
            id: 4,
            name: "APTR",
          },
          {
            id: 2,
            name: "UC",
            color: "#FBC02D",
          },
        ],
        doorExclusiveForSicsAssigned: true,
        doorExclusiveForTagsAssigned: false,
        baySics: ["ONT", "DAL"],
        bayTags: [
          {
            color: "#777DE9",
            id: 4,
            name: "APTR",
          },
          {
            id: 2,
            name: "UC",
            color: "#FBC02D",
          },
        ],
        bayExclusiveForSicsAssigned: false,
        bayExclusiveForTagsAssigned: true,
        bills: 0,
        loadedBills: 0,
        pieces: 0,
        pallets: 0,
        weight: 0,
        pulls: [
          {
            plannedPullId: 25457,
            trailerNumber: "DYLT170409",
            trailerEquipmentId: 1224,
            tripNumber: 3099732,
            stopSic: "",
            stopSicId: null,
            gateTime: "10:30 AM",
            carrierName: "MARSA TRANSPORTATION INC",
            status: "EMTY",
            trapName: "",
            isLoadAndHold: false,
            stopSicIds: [],
            isForeignTrailer: false,
            foreignTrailerDetails: null,
          },
          {
            plannedPullId: 25571,
            trailerNumber: "C244-2222",
            trailerEquipmentId: 1223,
            tripNumber: 3099732,
            stopSic: "",
            stopSicId: null,
            gateTime: "10:30 AM",
            carrierName: "MARSA TRANSPORTATION INC",
            status: "PLAN",
            trapName: "",
            isLoadAndHold: false,
            stopSicIds: [],
            isForeignTrailer: false,
            foreignTrailerDetails: null,
          },
        ],
        isCompleted: false,
      },
      {
        doorNumber: 5,
        priority: null,
        laneType: 0,
        doorSics: [],
        doorTags: [
          {
            color: "#777DE9",
            id: 4,
            name: "APTR",
          },
        ],
        doorExclusiveForSicsAssigned: true,
        doorExclusiveForTagsAssigned: false,
        baySics: ["ONT", "DAL"],
        bayTags: [
          {
            color: "#777DE9",
            id: 4,
            name: "APTR",
          },
          {
            id: 2,
            name: "UC",
            color: "#FBC02D",
          },
        ],
        bayExclusiveForSicsAssigned: false,
        bayExclusiveForTagsAssigned: true,
        bills: 0,
        loadedBills: 0,
        pieces: 0,
        pallets: 0,
        weight: 0,
        pulls: [
          {
            plannedPullId: 25572,
            trailerNumber: "DAL010",
            trailerEquipmentId: 1225,
            tripNumber: null,
            stopSic: "",
            stopSicId: null,
            gateTime: "10:30 AM",
            carrierName: "MARSA TRANSPORTATION INC",
            status: "EMTY",
            trapName: "",
            isLoadAndHold: false,
            stopSicIds: [],
            isForeignTrailer: false,
            foreignTrailerDetails: null,
          },
          {
            plannedPullId: 25573,
            trailerNumber: "DALGHOST03",
            trailerEquipmentId: 1222,
            tripNumber: 3099732,
            stopSic: "",
            stopSicId: null,
            gateTime: "10:30 AM",
            carrierName: "MARSA TRANSPORTATION INC",
            status: "EMTY",
            trapName: "",
            isLoadAndHold: false,
            stopSicIds: [],
            isForeignTrailer: false,
            foreignTrailerDetails: null,
          },
        ],
        isCompleted: false,
      },
      {
        doorNumber: 9,
        priority: 1,
        laneType: 0,
        doorSics: [],
        doorTags: [],
        doorExclusiveForSicsAssigned: false,
        doorExclusiveForTagsAssigned: false,
        baySics: [],
        bayTags: [],
        bayExclusiveForSicsAssigned: false,
        bayExclusiveForTagsAssigned: false,
        bills: 50,
        loadedBills: 25,
        pieces: 40,
        pallets: 30,
        weight: 10,
        pulls: [],
        isCompleted: false,
      },
      {
        doorNumber: 11,
        priority: 1,
        laneType: 4,
        doorSics: [],
        doorTags: [],
        doorExclusiveForSicsAssigned: false,
        doorExclusiveForTagsAssigned: false,
        baySics: [],
        bayTags: [],
        bayExclusiveForSicsAssigned: false,
        bayExclusiveForTagsAssigned: false,
        bills: 50,
        loadedBills: 25,
        pieces: 40,
        pallets: 30,
        weight: 10,
        pulls: [],
        isCompleted: false,
      },
      {
        planDoorId: 68530,
        doorNumber: 12,
        priority: null,
        doorSics: [],
        laneType: 0,
        doorTags: [
          {
            id: 3,
            name: "CC",
            color: "#EA5E5A",
          },
        ],
        doorExclusiveForTagsAssigned: false,
        baySics: [],
        bayTags: [],
        bayExclusiveForTagsAssigned: false,
        bills: 3,
        pieces: 0,
        pallets: 3,
        weight: 1470,
        loadedBills: 3,
        pulls: [
          {
            plannedPullId: 53542,
            trailerNumber: "480-4008",
            tripNumber: 3087088,
            stopSic: "",
            stopSicId: null,
            trailerEquipmentId: 24946,
            gateTime: "",
            carrierName: "COVENANT TRANSPORT INC",
            status: "ENRT",
            trapName: "",
            isLoadAndHold: false,
            stopSicIds: [],
            isForeignTrailer: false,
            foreignTrailerDetails: null,
          },
        ],
        bayExclusiveForSicsAssigned: false,
        doorExclusiveForSicsAssigned: false,
        isCompleted: true,
        act: "05:19",
        departureTime: "05:20",
      },
      {
        planDoorId: 68713,
        doorNumber: 89,
        priority: null,
        doorSics: [],
        laneType: 0,
        doorTags: [],
        doorExclusiveForTagsAssigned: false,
        baySics: [],
        bayTags: [],
        bayExclusiveForTagsAssigned: false,
        bills: 2,
        pieces: 370,
        pallets: 7,
        weight: 3963,
        loadedBills: 2,
        pulls: [
          {
            plannedPullId: 53556,
            trailerNumber: "281-4026",
            tripNumber: 10013876,
            stopSic: "",
            stopSicId: null,
            trailerEquipmentId: 24945,
            gateTime: "",
            carrierName: "AVILENO TRUCKING LLC",
            status: "CLOS",
            trapName: "",
            isLoadAndHold: false,
            stopSicIds: [],
            isForeignTrailer: false,
            foreignTrailerDetails: null,
          },
        ],
        bayExclusiveForSicsAssigned: false,
        doorExclusiveForSicsAssigned: false,
        isCompleted: true,
        act: "07:24",
        departureTime: "",
      },
    ],
  },
  bwi: {
    destinationSicId: 10,
    destinationSic: "BWI",
    laneType: 1,
    summary: {
      bills: 0,
      loadedBills: 0,
      pieces: 0,
      pallets: 0,
      weight: 0,
      loadedWeight: 0,
      pulls: 0,
      publishedTrips: 0,
      unassignedPublishedTrips: 0,
      tags: [
        {
          color: "#777DE9",
          id: 4,
          name: "APTR",
        },
        {
          id: 2,
          name: "UC",
          color: "#FBC02D",
        },
      ],
    },
    indicators: {
      unassignedBillsCount: 2,
      missServiceBillsCount: 3,
      pullsWithNoTrailersCount: 4,
      pullsWithNoTripCount: 5,
      lanesWithNoDoorsCount: 6,
    },
    doors: [
      {
        doorNumber: 4,
        priority: 1,
        laneType: 0,
        doorSics: ["BWI"],
        doorTags: [
          {
            color: "#777DE9",
            id: 4,
            name: "APTR",
          },
          {
            id: 2,
            name: "UC",
            color: "#FBC02D",
          },
        ],
        doorExclusiveForSicsAssigned: true,
        doorExclusiveForTagsAssigned: false,
        baySics: [],
        bayTags: [
          {
            color: "#777DE9",
            id: 4,
            name: "APTR",
          },
          {
            id: 2,
            name: "UC",
            color: "#FBC02D",
          },
        ],
        bayExclusiveForSicsAssigned: false,
        bayExclusiveForTagsAssigned: true,
        bills: 0,
        loadedBills: 0,
        pieces: 0,
        pallets: 0,
        weight: 0,
        pulls: [],
        isCompleted: false,
      },
    ],
  },
} as const satisfies Record<string, Lane>;
